module.exports = __webpack_public_path__ + "img/UTFHNH-8.23e8d5c7.jpg";